import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { Storage } from "@ionic/storage";
import { ServiceProvider } from "./../../providers/service/service";
import { Http, RequestOptions, Headers } from "@angular/http";
import { TranslateService } from "@ngx-translate/core";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController, LoadingController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-merchant-stat-shop",
  templateUrl: "merchant-stat-shop.html",
})
export class MerchantStatShopPage {
  round = 1;
  plaza = "";
  plaza_id = "";
  items = {
    plaza_id: "",
    plaza_name: "",
    total_unit_sold: 0,
    total_unit_sold_price: 0,
    shops: [
      {
        shop_id: "",
        shop_name: "",
        unit_sold: 0,
        stock_loss: 0,
        unit_sold_price: 0,
        stock_loss_price: 0,
      },
    ],
  };
  theme = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    public translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    this.storage.get("roundGame").then((round) => {
      this.round = round;
    });

    this.storage.get("info").then((info) => {
      this.plaza = info.team.plaza_name;
      this.plaza_id = info.team.plaza_id;
    });

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLMerchantStatUnitSold + this.plaza_id;

      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.items = data;
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  backPage() {
    this.navCtrl.pop();
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.push(MerchantHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-stat-shop/merchant-stat-shop.ts